import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router';
import { ChevronLeft, ChevronRight, Play, Pause, Clock, User } from 'lucide-react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './../../firebase'; // make sure this is your Firestore instance
import { getAuth, signOut } from "firebase/auth";
// import { Spinner } from './Spinner'; // optional custom loader component
function Blogs() {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();
    const cardStyles = {
        card: {
            backgroundColor: '#ffffff',
            maxWidth: '400px',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            height: '420px',
            display: 'flex',
            flexDirection: 'column',
            cursor: 'pointer',
            transform: 'translateY(0)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        },
        cardHover: {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 24px rgba(0, 0, 0, 0.2)',
        },
        button: {
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            transition: 'background-color 0.3s ease',
        },
        chip: {
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
            padding: '4px 12px',
            borderRadius: '16px',
            fontSize: '12px',
            fontWeight: '500',
            display: 'inline-block',
        }
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const blogCollection = collection(db, 'blogs');
                const snapshot = await getDocs(blogCollection);
                const blogList = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setBlogs(blogList);
            } catch (error) {
                console.error('Error fetching blogs:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);
    // const blogs = [
    //     {
    //         id: 1,
    //         title: "The Future of React: Server Components",
    //         excerpt: "Explore the latest React features including Server Components and Concurrent Rendering.",
    //         image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&h=250&fit=crop",
    //         author: "Sarah Johnson",
    //         date: "June 15, 2025",
    //         readTime: "8 min",
    //         category: "React"
    //     },
    //     {
    //         id: 2,
    //         title: "Next.js 15: App Router Optimization",
    //         excerpt: "Deep dive into Next.js 15's App Router and advanced caching strategies.",
    //         image: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=400&h=250&fit=crop",
    //         author: "Michael Chen",
    //         date: "June 12, 2025",
    //         readTime: "12 min",
    //         category: "Next.js"
    //     },
    //     {
    //         id: 3,
    //         title: "TypeScript 5.5: New Features",
    //         excerpt: "Discover the latest TypeScript features and improved type inference.",
    //         image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=400&h=250&fit=crop",
    //         author: "Emily Rodriguez",
    //         date: "June 10, 2025",
    //         readTime: "10 min",
    //         category: "TypeScript"
    //     },
    //     {
    //         id: 4,
    //         title: "AI-Powered Web Development",
    //         excerpt: "How AI is transforming web development with intelligent code generation.",
    //         image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=250&fit=crop",
    //         author: "David Park",
    //         date: "June 8, 2025",
    //         readTime: "15 min",
    //         category: "AI"
    //     },
    //     {
    //         id: 5,
    //         title: "Modern CSS: Container Queries",
    //         excerpt: "Master the latest CSS features including container queries and subgrid.",
    //         image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=250&fit=crop",
    //         author: "Lisa Wang",
    //         date: "June 5, 2025",
    //         readTime: "7 min",
    //         category: "CSS"
    //     },
    //     {
    //         id: 6,
    //         title: "Vue 3 Composition API Guide",
    //         excerpt: "Complete guide to Vue 3's Composition API and reactive programming.",
    //         image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=400&h=250&fit=crop",
    //         author: "Alex Kumar",
    //         date: "June 3, 2025",
    //         readTime: "9 min",
    //         category: "Vue"
    //     }
    // ];
    const handleKnowMore = (blogId) => {
        console.log(`Navigate to blog ${blogId}`);
        navigate(`/blogs/${blogId}`);
    };
    const handleLogout = async () => {
        try {
            await signOut(auth);
            console.log("User signed out successfully");
            navigate("/login"); // Redirect after logout
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };
    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: '40px' }}>
                <div
                    style={{
                        width: '40px',
                        height: '40px',
                        border: '4px solid #ccc',
                        borderTop: '4px solid #1976d2',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: 'auto',
                    }}
                />
                <p>Loading blogs...</p>
                <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
            </div>
        );
    }


    return (
        <div style={{ padding: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 20px 20px' }}>
                <button
                    onClick={() => navigate('/post-blog')}
                    style={{
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        color: 'white',
                        padding: '12px 28px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        margin: '20px',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                        transition: 'transform 0.2s ease-in-out',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    + Create Blog
                </button>
                <button
                    onClick={handleLogout}
                    style={{
                        background: 'linear-gradient(to right, #d32f2f, #c2185b)',
                        color: 'white',
                        padding: '12px 28px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        margin: '20px',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                        transition: 'transform 0.2s ease-in-out',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    Logout
                </button>
            </div>
            <div
                style={{
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '20px',
                }}
            >
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '20px',
                    }}
                >
                    {blogs.map((blog, index) => (
                        <div
                            key={blog.id}
                            style={{
                                ...cardStyles.card,
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            }}
                            onMouseEnter={(e) => {
                                Object.assign(e.currentTarget.style, cardStyles.cardHover);
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                            }}
                        >
                            {/* Image */}
                            <div style={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
                                {blog.featuredType === 'video' ? (
                                    <video
                                        src={blog.featuredImage}
                                        controls
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={blog.featuredImage}
                                        alt={blog.title}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => (e.target.style.transform = 'scale(1.05)')}
                                        onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
                                    />
                                )}

                                <div style={{ position: 'absolute', top: '12px', left: '12px' }}>
                                    <span style={cardStyles.chip}>{blog.category}</span>
                                </div>
                            </div>

                            {/* Content */}
                            <div
                                style={{
                                    padding: '20px',
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <h3
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#212121',
                                        margin: '0 0 12px 0',
                                        lineHeight: '1.4',
                                        height: '50px',
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        fontFamily: 'Roboto, sans-serif',
                                    }}
                                >
                                    {blog.title}
                                </h3>

                                <p
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        lineHeight: '1.5',
                                        margin: '0 0 16px 0',
                                        flex: 1,
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                    }}
                                >
                                    {/* {blog.excerpt} */}
                                </p>

                                {/* Meta Info */}
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '16px',
                                        fontSize: '12px',
                                        color: '#888',
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <User size={14} />
                                        <span>{blog.author?.name}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                        <Clock size={14} />
                                        <span>{blog?.readTime}</span>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <span style={{ fontSize: '12px', color: '#999' }}>{blog.date}</span>
                                    <button
                                        onClick={() => handleKnowMore(blog.id)}
                                        style={cardStyles.button}
                                        onMouseEnter={(e) =>
                                            (e.target.style.backgroundColor = '#1565c0')
                                        }
                                        onMouseLeave={(e) =>
                                            (e.target.style.backgroundColor = '#1976d2')
                                        }
                                    >
                                        Know More
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

}

export default Blogs
